import Http from "../../http/client";

export default async ({userId, startDate, endDate, period, status}) => {
    const response = await Http.get(`admin/trip-actions-report/${userId}`, {
        params: {
            startDate,
            endDate,
            period,
            status
        }
    });

    return response.data;
}
